<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex>
        <v-text-field v-model="generatedString" hide-details outline single-line></v-text-field>
      </v-flex>
      <v-flex shrink>
        <v-btn color="primary" @click="copyGeneratedString" :disabled="!generatedString" icon large><v-icon>fa-copy</v-icon></v-btn>
      </v-flex>
      <v-flex xs12>
        <v-btn @click="generateTerminalID" color="primary">Terminal ID</v-btn>
        <v-btn @click="generateGUID" color="primary">GUID</v-btn>
        <v-btn @click="generateKSUID" color="primary">KSUID</v-btn>
        <v-btn @click="parseKSUID" color="secondary" v-show="generatedString">Parse KSUID</v-btn>
      </v-flex>

      <v-flex xs12>
        <v-sheet class="align-baseline d-inline-flex pa-2" elevation="1">
          <v-text-field class="shrink" label="Length" v-model="stringLength" type="number"></v-text-field>
          <v-switch color="primary" hide-details label="Alpha Only" v-model="stringAlphaOnly"></v-switch>
          <v-btn @click="generateString" color="primary">Custom</v-btn>
        </v-sheet>
      </v-flex>

      <v-flex xs12 v-show="response || ksuid">
        <v-sheet color="pa-2 secondary">
          {{ response }}

          <template v-if="ksuid">
            <b>Date:</b> {{ ksuid.date }}
            <br />
            <b>Payload (Raw):</b> <v-textarea hide-details outline rows="2" v-model="ksuid.payload" readonly></v-textarea>
            <b>Payload (Base64):</b> <v-textarea hide-details outline rows="2" v-model="encodedKSUIDPayload" readonly>{{ encodeKSUIDPayload(ksuid.payload) }}</v-textarea>
          </template>
        </v-sheet>
      </v-flex>
    </v-layout>

    <v-snackbar bottom centered color="success" v-model="isCopied">
      <v-layout row wrap align-center>
        <v-flex>
          <v-icon>fa-info-circle</v-icon>
        </v-flex>
        <v-flex subheading>
          Link copied to clipboard
        </v-flex>
      </v-layout>
    </v-snackbar>
  </v-container>
</template>

<script>
import KSUID from 'ksuid'
import { v4 as UUIDV4 } from 'uuid'

// import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin, UtilityMixin],

  data: function () {
    return {
      stringLength: 0,
      stringAlphaOnly: true,
      generatedString: '',
      isCopied: false,
      response: '',
      ksuid: null
    }
  },
  computed: {
    encodedKSUIDPayload () {
      return btoa(encodeURIComponent(this.ksuid.payload))
    }
  },
  methods: {
    convert () {
      let buffer = Buffer.from(this.encoded, 'base64')
      let frame = document.getElementById('decoded').contentWindow.document
      frame.open()
      frame.write(buffer.toString('ascii'))
      frame.close()
    },
    generateString () {
      this.generatedString = this.generateRandomString(this.stringLength, this.stringAlphaOnly)
    },
    copyGeneratedString () {
      this.isCopied = true
      return navigator.clipboard.writeText(this.generatedString)
    },
    generateTerminalID () {
      this.stringLength = 12
      this.generatedString = this.generateRandomString(12).toUpperCase()
    },
    generateGUID () {
      this.stringLength = 36
      this.generatedString = UUIDV4()
    },
    generateKSUID () {
      this.stringLength = 27
      this.generatedString = KSUID.randomSync().string
    },
    parseKSUID () {
      this.response = ''
      this.ksuid = null

      if (this.generatedString) {
        try {
          this.ksuid = KSUID.parse(this.generatedString)
        } catch (error) {
          this.response = `Error: ${error}`
        }
      }
    },
    encodeKSUIDPayload (payload) {
      return btoa(encodeURIComponent(this.ksuid.payload))
    }
  }
}
</script>

<style>
#decoded {
  height: 100%;
  resize: both;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/utilities/StringGenerator.vue